import React from "react";
import CardComex from "./CardComex";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import useStore from "../store/useStore";
import { useEffect } from "react";

export default function TestimoniosComex() {
  const { getTestimonioComex, testimonioComex } = useStore();
  useEffect(() => {
    getTestimonioComex();
  }, [getTestimonioComex]);

  return (
    <section className="w-full bg-sidom-blue py-16 flex flex-col items-center justify-center">
      <h2 className="text-left container w-full text-3xl md:text-4xl lg:text-5xl font-extrabold text-sidom-orange mb-8">
        Testimonios
      </h2>
      <div className="w-full max-w-6xl">
        <Swiper
          spaceBetween={32}
          slidesPerView={1}
          breakpoints={{
            768: { slidesPerView: 2 },
            1200: { slidesPerView: 3 },
          }}
          loop={true}
        >
          {testimonioComex.map((t, idx) => (
            <SwiperSlide key={idx}>
              <CardComex
                key={t.id}
                img={
                  t.img?.[0]?.formats?.thumbnail?.url
                    ? `${t.img[0].formats.thumbnail.url}`
                    : t.img?.[0]?.url
                    ? `${t.img[0].url}`
                    : "/placeholder.jpg"
                }
                logo={t.logo}
                nombre={t.nombre}
                empresa={t.empresa}
                cargo={t.cargo}
                texto={t.descripcion}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
